(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("site-bi", [], factory);
	else if(typeof exports === 'object')
		exports["site-bi"] = factory();
	else
		root["site-bi"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 